<svg
  width="29"
  height="28"
  viewBox="0 0 29 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14.3276 9.3335V14.0002M14.3276 18.6668H14.3393M25.9943 14.0002C25.9943 20.4435 20.7709 25.6668 14.3276 25.6668C7.88429 25.6668 2.66095 20.4435 2.66095 14.0002C2.66095 7.55684 7.88429 2.3335 14.3276 2.3335C20.7709 2.3335 25.9943 7.55684 25.9943 14.0002Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
